var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockCalendarItem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "schedule_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.391,
    height: 21.39,
    viewBox: "0 0 21.391 21.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7540",
    "data-name": "Path 7540",
    d: "M0,0H21.39V21.39H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7541",
    "data-name": "Path 7541",
    d: "M10.9,2a8.913,8.913,0,1,0,8.922,8.913A8.908,8.908,0,0,0,10.9,2Zm.009,16.043a7.13,7.13,0,1,1,7.13-7.13A7.128,7.128,0,0,1,10.913,18.043Zm.446-11.587H10.021V11.8L14.7,14.611l.668-1.1-4.011-2.38Z",
    transform: "translate(-0.217 -0.217)",
    fill: "#a2adbf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockCalendarItem);
export default __webpack_public_path__ + "static/media/clock_calendar_item.180aa561df73477fdbd9eb766eeabfdd.svg";
export { ForwardRef as ReactComponent };